<template>
  <b-modal
    v-model="isOpen"
    size="lg"
    centered
    hide-header
    hide-footer
    @hidden="onHidden"
  >
    <div class="modal-header-row p-3">
      <button type="button" class="close-btn" @click="close">
        <span aria-hidden="true">&times;</span>
      </button>
      <p class="company-name">{{ contact.companyName }}</p>
      <p class="subject-text">{{ contact.subject }}</p>
    </div>

    <div class="modal-body-content px-5 pb-3">
      <h5 class="section-title">今回の応募は控えますか？</h5>
      <textarea
        class="form-control message-textarea"
        rows="4"
        v-model="message"
        placeholder="任意記入：応募を控えるにあたって企業へ伝えたいメッセージがあればご記入ください"
      ></textarea>
      <div class="d-flex justify-content-center mt-3">
        <button class="btn btn-refrain-submit" @click="onRefrain" :disabled="isSubmitting">
          今回は控える
        </button>
      </div>
    </div>

    <div class="different-position-section">
      <div class="hint-row">
        <svg width="24" height="24" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" class="hint-icon">
          <g clip-path="url(#clip0_18782_41135)">
            <path d="M18.5053 10.6562C16.2883 10.6562 14.2083 11.52 12.6453 13.0828C11.082 14.6461 10.2188 16.7263 10.2188 18.9368C10.2188 21.1539 11.082 23.2339 12.6453 24.7971L12.6712 24.8233C12.8609 25.006 13.0701 25.1894 13.2991 25.3724L13.5935 28.6032C13.43 28.6823 13.2929 28.7999 13.1946 28.9504C13.0639 29.1596 13.0179 29.408 13.0769 29.6502L13.1227 29.8791C13.2012 30.2193 13.456 30.4674 13.77 30.5594L13.8224 31.1153L13.7767 31.1279C13.2796 31.2395 12.9657 31.7363 13.0769 32.234L13.1227 32.4621C13.1816 32.7046 13.3254 32.9073 13.5348 33.0447C13.6788 33.1362 13.8422 33.1819 14.0122 33.1884L14.1691 34.9281H15.4315C15.935 36.1776 17.1388 37.0018 18.5053 37.0018C19.8724 37.0018 21.0823 36.1843 21.5797 34.9282H22.8353L23.182 31.1608L23.2341 31.1477C23.7316 31.0365 24.0454 30.5394 23.934 30.0426L23.882 29.8137C23.8165 29.526 23.62 29.2971 23.3587 29.1793L23.4238 28.499C23.8097 28.3158 24.0325 27.8907 23.934 27.4591L23.882 27.2299C23.836 27.0404 23.7316 26.8702 23.5808 26.7395L23.7118 25.3723C23.934 25.1894 24.1502 24.9997 24.3594 24.797C25.9224 23.2337 26.7859 21.1538 26.7859 18.9367C26.7859 16.7261 25.9224 14.646 24.3594 13.0827C22.7961 11.52 20.7161 10.6562 18.5053 10.6562ZM21.4423 26.7404L21.403 27.1712L16.369 28.3009L15.7195 28.4452L15.5687 26.7395H20.9596L21.4423 26.7404ZM15.9545 30.9767L15.8498 29.8792L21.2658 28.669L21.1608 29.8072L16.5296 30.8489L15.9545 30.9767ZM20.6118 24.8163C20.6118 24.8163 20.6118 25.1435 20.6118 25.5754H16.3994C16.3994 25.1435 16.3994 24.8163 16.3994 24.8163C15.9153 24.6009 14.9019 24.0121 14.1561 23.286C13.0442 22.1742 12.3509 20.6371 12.3509 18.9368C12.3509 17.2428 13.0442 15.7058 14.1561 14.5871C15.268 13.4755 16.8051 12.7884 18.5053 12.7884C20.1996 12.7884 21.7364 13.4755 22.855 14.5871C23.9667 15.7058 24.6535 17.2428 24.6535 18.9368C24.6535 20.6371 23.9667 22.1742 22.855 23.286C22.1028 24.0121 21.0891 24.6009 20.6118 24.8163ZM19.6827 32.7961V33.725C19.6633 34.3594 19.1464 34.8691 18.5053 34.8691C17.8513 34.8691 17.3217 34.3464 17.3217 33.6923V32.7961H16.1183L16.0856 32.4099L21.0236 31.305L20.8865 32.7961H19.6827Z" fill="#2F2E41"/>
            <path d="M20.044 18.6542C19.9065 18.6084 19.7626 18.6542 19.6776 18.7719C19.6254 18.844 19.5729 18.9286 19.5141 19.0337C19.305 19.38 19.017 19.8644 18.5854 19.8644C18.0948 19.8644 17.6629 19.2496 17.4408 18.9224C17.395 18.8634 17.3623 18.8112 17.3298 18.772C17.2446 18.6543 17.1006 18.6085 16.9634 18.6543C16.813 18.6997 16.7147 18.8573 16.7277 19.0269L17.6697 23.9195L18.1276 23.8473L18.1405 23.8411H18.147L17.7089 21.5647L17.5062 20.4993L17.3428 19.585C17.6361 19.9404 18.0502 20.3088 18.5854 20.3088C18.9973 20.3088 19.305 20.0866 19.5336 19.8253C19.5701 19.7888 19.5991 19.7476 19.6305 19.7084C19.6491 19.6886 19.6683 19.6695 19.6881 19.6511L19.043 23.7363L19.0235 23.8411V23.8473L19.5011 23.913L20.2791 19.0467V19.0269C20.2924 18.8572 20.1945 18.6996 20.044 18.6542Z" fill="#2F2E41"/>
            <path d="M18.5009 5.98028C18.8967 5.98114 19.2247 5.67546 19.2523 5.28082L19.5555 0.80259C19.5854 0.370152 19.2427 0.00289841 18.8097 0.00203122L18.2294 7.78189e-06C17.7958 -0.00194339 17.4517 0.363287 17.478 0.796375L17.7549 5.27627C17.7791 5.67091 18.1055 5.97912 18.5009 5.98028Z" fill="#2F2E41"/>
            <path d="M11.1575 8.99506C11.4383 8.71648 11.4544 8.26764 11.1941 7.97041L8.24231 4.58859C8.21608 4.55839 8.18045 4.54451 8.15053 4.51936C8.12878 4.50101 8.10645 4.4841 8.08304 4.46856C8.01525 4.42368 7.94559 4.3921 7.86935 4.3718C7.84955 4.36616 7.82982 4.36103 7.80944 4.35742C7.57718 4.31507 7.3301 4.36898 7.14835 4.54935L6.7368 4.95867C6.42967 5.26406 6.44434 5.76602 6.76874 6.05313L10.1327 9.02534C10.4286 9.28694 10.8775 9.27372 11.1575 8.99506Z" fill="#2F2E41"/>
            <path d="M30.2652 5.03096L29.8565 4.61912C29.6753 4.43708 29.4277 4.38172 29.1943 4.4232C29.1739 4.42689 29.1542 4.43202 29.1344 4.43737C29.0585 4.45738 28.989 4.48839 28.9215 4.53276C28.8978 4.54801 28.8758 4.5647 28.8538 4.58269C28.8241 4.60755 28.7886 4.62107 28.762 4.65106L25.7898 8.01502C25.5278 8.31117 25.5407 8.76001 25.8197 9.04062C26.0983 9.32086 26.5468 9.33676 26.8449 9.07646L30.2267 6.12513C30.5534 5.83939 30.5713 5.3383 30.2652 5.03096Z" fill="#2F2E41"/>
          </g>
          <defs>
            <clipPath id="clip0_18782_41135">
              <rect width="37" height="37" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <span class="hint-text">他の求人のスカウトを、企業に希望できます</span>
      </div>
      <button class="btn btn-see-jobs" @click="onGoToJobs">
        この企業の求人を見る
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'RefrainPositionModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    contact: {
      type: Object,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: ''
    };
  },
  computed: {
    isOpen: {
      get() { return this.show; },
      set(val) { if (!val) this.$emit('hide'); }
    }
  },
  methods: {
    close() {
      this.$emit('hide');
    },
    onHidden() {
      this.$emit('hide');
    },
    onRefrain() {
      this.$emit('submitRefrain', this.message);
      this.message = '';
    },
    onGoToJobs() {
      this.$emit('hide');
      this.$nextTick(() => {
        this.$emit('goToJobs');
      });
    }
  }
}
</script>

<style scoped>
::v-deep .modal-body {
  padding: 0 !important;
}

::v-deep .modal-content {
  border-radius: 0 !important;
}

::v-deep .modal-lg {
  max-width: 640px;
}

::v-deep .modal-dialog {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-header-row {
  position: relative;
  border-bottom: 1px solid #dee2e6;
  text-align: center;
  padding-right: 36px;
}

.company-name {
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 2px;
}

.subject-text {
  font-size: 12px;
  color: #555;
  margin: 0;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  color: #000;
  opacity: 0.7;
}

.close-btn:hover {
  opacity: 1;
}

.section-title {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin: 16px 0 12px;
}

.message-textarea {
  background-color: #f4f5f5;
  resize: none;
  font-size: 13px;
  width: 100%;
}

.btn-refrain-submit {
  background-color: #515C6B;
  color: #fff;
  border: none;
  border-radius: 4px;
  width: 100%;
  height: 50px;
  font-size: 15px;
  font-weight: bold;
}

.btn-refrain-submit:hover {
  background-color: #3e4a57;
  color: #fff;
}

.btn-refrain-submit:disabled {
  opacity: 0.7;
}

.different-position-section {
  background-color: #E7F6F6;
  padding: 20px;
  text-align: center;
  border-top: 1px solid #dee2e6;
}

.hint-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.hint-icon {
  flex-shrink: 0;
}

.hint-text {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.btn-see-jobs {
  background-color: #fff;
  color: #333;
  border: 1px solid #333;
  border-radius: 4px;
  width: 280px;
  height: 44px;
  font-size: 14px;
  font-weight: bold;
}

.btn-see-jobs:hover {
  background-color: #f5f5f5;
}

@media (max-width: 767px) {
  .btn-refrain-submit,
  .btn-see-jobs {
    width: 100%;
  }
}
</style>
